// Where the resume lives and whether it is on offer.
//
// Two places link to it, the hero and the contact panel, and both have to agree
// about a switch that is flipped from a phone. This keeps that decision in one
// place instead of in each of them.

import { computed } from 'vue';
import { personalInfo } from '~/data/content';

export function useResume() {
  const { useSettings } = useLiveContent();
  const settings = useSettings();

  // An uploaded copy wins; otherwise the one committed to the repository, so
  // the link works before anything has been uploaded and if the database is
  // unreachable.
  const url = computed(() => settings.value.resumeUrl || personalInfo.resumeUrl);

  // A URL as well as the switch. There is no committed copy any more, so
  // without one the button would link to a 404 whenever the setting could not
  // be read.
  const available = computed(() => settings.value.resumeEnabled !== false && Boolean(url.value));

  // Open while the setting has not been turned off. The panel that asks for it
  // is opened by the caller, since only the caller knows what it is attached
  // to.
  return { url, available };
}
